/**
 * 記事の公開ステータスの文字列を生成するフィルタ。
 */
import moment, { Moment } from 'moment'
import { ContentItem } from '../api/gerbera/contents'
import { PublishStatus } from '../api/gerbera/core'

const PUBLISH_STATUS_MAP = {
  published: '公開中',
  reserved: '予約済',
  pending: '非公開'
}

/**
 * 公開ステータスの文字列を生成する。使い方は以下の通り
 * {{ contentItem | publishStatus }}
 *
 * @param {string} fileName - ファイル名
 * @param {number} siteId - サイトID
 * @param {number} contentId - コンテンツID
 */
export default function publishStatus(contentItem: ContentItem, nowDate: Date = new Date()): string {
  return PUBLISH_STATUS_MAP[computePublishStatus(contentItem, nowDate)]
}

function toMoment(date: string | Date | undefined): Moment | undefined {
  return date ? moment(date) : undefined
}

export function computePublishStatus(contentItem: ContentItem, nowDate: Date = new Date()): PublishStatus {
  if (contentItem.status) {
    return contentItem.status
  }

  const published = toMoment(contentItem.publishedDate)
  const expires = toMoment(contentItem.expiresDate)
  const now = moment(nowDate)

  if (!published || !expires) {
    return 'pending'
  }
  if (now.isBetween(published, expires)) {
    return 'published'
  }
  if (expires.isAfter(now) && published.isAfter(now)) {
    return 'reserved'
  }
  return 'pending'
}
